<template>
    <header class="Mybar bg_white">
        <div class="mybarLeft" v-on:click="toPrev">
            <span class="iconfont icon-zuojiantou f12 color_999" />
        </div>
        <div class="myTitle" v-html="title" />
        <slot name="right"></slot>
    </header>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        props: {
            title: {
                type: String
            }
        },
        computed: {
            ...mapState(['app'])
        },
        methods: {
            toPrev: function () {
                if (this.app.history.length <= 1) {
                    this.$router.push('/')
                } else {
                    this.$router.back();
                }
            },
        }
    }
</script>

<style scoped>

</style>
